"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddHostsContextProvider = exports.AddHostsContext = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
exports.AddHostsContext = react_1.default.createContext({});
const AddHostsContextProvider = ({ cluster, resetCluster, ocpConsoleUrl, canEdit = true, children, }) => (react_1.default.createElement(exports.AddHostsContext.Provider, { value: { cluster, resetCluster, ocpConsoleUrl, canEdit } }, children));
exports.AddHostsContextProvider = AddHostsContextProvider;
//# sourceMappingURL=AddHostsContext.js.map